import React from 'react';
import { Icon, TextInput } from '@doxyme/ui';
export const SearchField = ({ value, onSearch, placeholder = '', }) => (<div className="search-field form-field__wrapper">
    <TextInput value={value} placeholder={placeholder} onChange={(event) => onSearch(event.target.value)} startAdornment={<Icon name="search" size="x-small"/>} endAdornment={value && (<button className="button--clear-icon button--filter-clear" type="button" onClick={() => onSearch('')}>
            <Icon className="button__icon button__icon--clear" name="call-settings-close" size="xx-small"/>
          </button>)}/>
  </div>);
